module.exports = __webpack_public_path__ + "static/media/vibrant-1.cd22be24.png";